import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { Cancel, Search } from '@mui/icons-material'

function SearchTxtFieldClr({ searchKeyWord, onSearch, placeholder, onBtnClick, variant, handleOnClear }) {
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onBtnClick?.();
        }
    };

    return (
        <Box width={250}>
            <TextField variant={variant ? variant : "standard"} fullWidth 
                value={searchKeyWord}
                onChange={onSearch && onSearch}
                onKeyDown={handleKeyDown}
                sx={{
                    "& .MuiInputBase-root": {
                        height: 35
                    }
                }}
                placeholder={placeholder}
                InputProps={onBtnClick ? {
                    endAdornment: (
                        <InputAdornment position={"end"} >
                            {searchKeyWord && ( // Show Clear button only if text exists
                                <IconButton onClick={handleOnClear} sx={{ color: "gray" }}>
                                    <Cancel fontSize="small" />
                                </IconButton>
                            )}
                            {onBtnClick && (
                                <IconButton onClick={onBtnClick} >
                                    <Search color='primary' />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                    style: { paddingLeft: 3, paddingRight: 3 },
                } : {
                    startAdornment: (
                        <InputAdornment position={"start"}>
                            <IconButton>
                                <Search color='primary' />
                            </IconButton>
                        </InputAdornment>
                    ),
                    style: { paddingLeft: 3, paddingRight: 6 },
                }}
            />
        </Box>
    )
}

export default SearchTxtFieldClr